import React from 'react';
import { 
  HelpCircle, 
  Lightbulb, 
  Droplets, 
  Zap, 
  ArrowDownWideNarrow, 
  Eye, 
  Sparkles,
  AlertCircle
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: Lightbulb,
      title: 'Выбор цветовой температуры',
      description: 'Для жилых комнат выбирайте тёплый свет (2700-3000K), для кухни и ванной - нейтральный (4000K), для рабочих зон - дневной (5000-6500K).'
    },
    {
      icon: Droplets,
      title: 'Уход за светильниками',
      description: 'Регулярно очищайте светильники от пыли для поддержания уровня освещенности. Загрязнение может снизить яркость на 20-30%.'
    },
    {
      icon: Zap,
      title: 'Энергоэффективность',
      description: 'Светодиодные лампы потребляют в 7-10 раз меньше энергии, чем лампы накаливания при той же яркости и служат в 15-20 раз дольше.'
    },
    {
      icon: ArrowDownWideNarrow,
      title: 'Высота подвеса',
      description: 'Оптимальная высота подвеса светильников для общего освещения составляет около 2/3 от высоты помещения.'
    },
    {
      icon: Eye,
      title: 'Защита зрения',
      description: 'Выбирайте светильники с защитой от слепящего эффекта (UGR < 19) для рабочих мест и мест продолжительного пребывания.'
    },
    {
      icon: Sparkles,
      title: 'Индекс цветопередачи',
      description: 'Для комфортного восприятия цветов выбирайте лампы с индексом цветопередачи CRI > 80. Для художественных задач - более 90.'
    },
    {
      icon: AlertCircle,
      title: 'Пульсации света',
      description: 'Для снижения усталости глаз выбирайте качественные LED светильники с коэффициентом пульсации не более 5%.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-amber-500" />
        Советы по освещению
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-amber-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Российские нормативы
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Расчеты соответствуют СП 52.13330.2016 и СанПиН 1.2.3685-21. Наш калькулятор поможет соблюсти требования для всех типов помещений.
            </p>
            <div className="text-xs text-blue-600 dark:text-blue-400">
              Подробнее в 
              <a href="https://docs.cntd.ru/document/456054197" target="_blank" rel="noopener noreferrer" className="text-blue-700 dark:text-blue-300 hover:underline ml-1">
                СП 52.13330.2016
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;